<template>
  <modal 
    name="rename-modal" 
    :pivotY="0.2"
    :height="'auto'"
    :width="500"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Rename file
      </div>

      <a href="#"
        @click.prevent="$modal.hide('rename-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">
      <label class="text-sm">File name</label>
      
      <div class="form-line">
        <input type="text" v-model="fileName" ref='fileName' class="input-standard" :disabled="loading" />
        <div v-if="fileNameError !== null" class="input-error">{{ fileNameError }}</div>
      </div>

      <div class="button-line">
        <SubmitButton :onClick="submit" :loading="loading" label="Save" :isFullWidth="true" />
      </div>
    </div>
  </modal>
</template>

<script>
  import SubmitButton from '@/shared/components/form/SubmitButton'
  
  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        loading      : false,
        fileName     : null,
        fileNameError: null,
        fileId       : null,
        documentIndex: null,
        fileIndex    : null,
      }
    },

    methods : {
      beforeOpen(event) {
        this.fileName       = event.params.fileName
        this.fileNameError  = null
        this.fileId         = event.params.fileId
        this.documentIndex  = event.params.documentIndex
        this.fileIndex      = event.params.fileIndex
        this.renameFileDone = event.params.renameFileDone
      },

      opened() {
        this.$refs.fileName.focus()
      },

      close() {
        this.$modal.hide('rename-modal')
      },

      submit() {
        let valid          = true
        this.fileNameError = null

        if(this.fileName == null || this.fileName.length == 0) {
          this.fileNameError = "Please type a valid name."
          valid = false;
        }

        if(valid) {
          this.loading = true

          this.apiPost({
            fileName: this.fileName,
            fileId  : this.fileId,
            clientId: this.$route.params.clientId,
          }, 'document/rename-file', (data) => {
            this.loading = false
            this.renameFileDone(this.documentIndex, this.fileIndex, this.fileName)
            this.close()
          })
        }
      },
    },
  }
</script>